import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

export const routes: Routes = [
  { path: '', redirectTo: 'access-code', pathMatch: 'full' },
  { path: '**', redirectTo: 'access-code' }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, { useHash: true });
